//arza deploy
//brayan la rompio
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
//Brayan la va sacar del estaddio hoy
function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
